import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, green, unityGreen } from '../colors';
import { GetThemeOptions } from '../../theme';

export const successColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  const { panwRebrandStubYear } = opts;
  if (panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityGreen[500],
          highContrast: unityGreen[700],
          lowContrast: unityGreen[100],
        }
      : {
          main: unityGreen[400],
          highContrast: unityGreen[100],
          lowContrast: unityGreen[800],
        };
  }

  return mode === 'light'
    ? {
        main: green[500],
        highContrast: green[700],
        lowContrast: green[100],
      }
    : {
        main: green[400],
        highContrast: green[100],
        lowContrast: green[800],
      };
};
